<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="remark.id > 0; else addTitle">Edit {{windowTitle}}</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <p class="edit-remark__headertext">Remark Text:</p>
      <mat-form-field hintLabel="Max 1000 characters" class="edit-remark_text__formfield">
        <textarea matInput #text maxlength="1000" name="text" formControlName="text"
                  [(ngModel)]="selectedText" class="edit-remark_text__textarea"></textarea>
        <mat-hint align="end">{{text.value?.length || 0}}/1000</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add {{windowTitle}}
</ng-template>
